<template>
  <div>
    <app-cells><h1 class="title">Safari analytics</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'SafariAnalyticsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'safari-analytics-general', label: 'General' },
        { name: 'safari-analytics-snacks', label: 'Snack bar' },
        { name: 'safari-analytics-flying-doctors', label: 'Flying Doctors' },
      ],
    }
  },
}
</script>
